<div class="whitelist-item-detail">
  @switch (add?.sub_type) {
    @case (1) {
      <div>
        <table class="table">
          <tr>
            <th>Lagerplatz</th>
            <th>Charge</th>
            <th>Wareneingangsdatum</th>
            <th class="align-right">Preis</th>
            <th class="align-right">Menge</th>
          </tr>
          @for (transaction of add.transactions; track transaction) {
            <tr>
              <td>{{transaction.location}}</td>
              <td>{{transaction.charge}}</td>
              <td>{{transaction.date_received|date:'dd.MM.yyyy'}}</td>
              <td class="align-right">{{transaction.price|money:2}}&nbsp;&euro;</td>
              <td class="align-right">{{transaction.amount|money}}</td>
            </tr>
          }
        </table>
      </div>
    }
    @case (3) {
      <div>
        <material-order-position-status-label [status]="add.position_state_old">
        </material-order-position-status-label>
        <i class="fa fa-arrow-right"></i>
        <material-order-position-status-label [status]="add.position_state_new">
        </material-order-position-status-label>
      </div>
    }
    @case (4) {
      <div>
        @if (('material.order.price.check'|HasPerm)) {
          <table class="table">
            <tr>
              <th class="align-right">Einbuchung</th>
              <th class="align-right">Alter Preis</th>
              <th class="align-right">Neuer Preis</th>
            </tr>
            @for (transaction of add.transaction_price_changes; track transaction) {
              <tr>
                <td class="align-right"><b>{{transaction.transaction_index}}.</b></td>
                <td class="align-right">{{transaction.price_old|money:2}}&nbsp;&euro;</td>
                <td class="align-right">{{transaction.price_new|money:2}}&nbsp;&euro;</td>
              </tr>
            }
          </table>
        }
      </div>
    }
  }
</div>
